import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Unregister ALL service workers permanently
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
  caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
}

// Clear corrupted Supabase auth locks from IndexedDB
// Prevents the 5000ms lock timeout that causes infinite spinners
try {
  indexedDB.deleteDatabase('supabase-storage');
} catch(e) {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);